import React from 'react';
import PropTypes from 'prop-types';

import md5 from 'md5';
import money from 'money-math';

import './style.css';

/* eslint-disable max-len */
export class InvestorInvite extends React.PureComponent {
  renderAllocated() {
    const {invite} = this.props;
    const {user, allocation} = invite;
    const lead = (invite.type === 'lead' && ' (Manager)') || '';
    const name = `${user.firstName} ${user.lastName}${lead}`;
    const amount = `${money.format('USD', money.floatToAmount(allocation.investment.amount / 100))}`;
    return (
      <div styleName="row">
        <div styleName="name item">
          <img src={user.image} alt="" />
          <span>
            {name}
            <br />
            <span styleName="inline_status allocated">
              Committed to invest ${amount}
            </span>
          </span>
        </div>
        <div styleName="allocated item status">
          Committed to invest ${amount}
        </div>
      </div>
    );
  }
  renderAccepted() {
    const {invite} = this.props;
    const {user} = invite;
    const lead = (invite.type === 'lead' && ' (Manager)') || '';
    const name = `${user.firstName} ${user.lastName}${lead}`;
    return (
      <div styleName="row">
        <div styleName="name item">
          <img src={user.image} alt="" />
          <span>
            {name}
            <br />
            <span styleName="inline_status accepted">
              Still Considering
            </span>
          </span>
        </div>
        <div styleName="accepted item status">
          Still Considering
        </div>
      </div>
    );
  }
  renderNotAccepted() {
    const {invite} = this.props;
    const hash = md5(invite.email);
    const lead = (invite.type === 'lead' && ' (Manager)') || '';
    const name = `${invite.email}${lead}`;
    return (
      <div styleName="row">
        <div styleName="name item">
          <img src={`https://robohash.org/${hash}?gravatar=hashed&set=1`} alt="" style={{opacity: 0.8}} />
          <span>
            {name}
            <br />
            <span styleName="inline_status not_accepted">
              Hasn’t opened invite yet
            </span>
          </span>
        </div>
        <div styleName="not_accepted item status">
          Hasn’t opened invite yet
        </div>
      </div>
    );
  }
  renderSelfAccepted() {
    const {invest, invite: {user}} = this.props;
    return (
      <div styleName="row">
        <div styleName="name item">
          <img src={user.image} alt="" />
          <span>
            You
            <br />
            <span styleName="inline_status accepted">
              Waiting for you to&nbsp;
              <a onClick={invest} role="button" tabIndex="0" data-test="lead_invite_invest_inline">invest</a>
            </span>
          </span>
        </div>
        <div styleName="item status accepted">
          Waiting for you to&nbsp;
          <a onClick={invest} role="button" tabIndex="0" data-test="lead_invite_invest"> invest</a>
        </div>
      </div>
    );
  }
  renderSelfAllocated() {
    const {invest, invite: {user, allocation}} = this.props;
    const amount = `${money.format('USD', money.floatToAmount(allocation.investment.amount / 100))}`;
    return (
      <div styleName="row">
        <div styleName="name item">
          <img src={user.image} alt="" />
          <span>
            You
            <br />
            <span styleName="inline_status allocated">
              Committed to invest ${amount}&nbsp;
              <a onClick={invest} role="button" tabIndex="0" data-test="lead_invite_invest_inline">Change</a>
            </span>
          </span>
        </div>
        <div styleName="allocated item status">
          Committed to invest ${amount}&nbsp;
          <a onClick={invest} role="button" tabIndex="0" data-test="lead_invite_invest">Change</a>
        </div>
      </div>
    );
  }
  render() {
    const {invite, user} = this.props;
    if (invite.user && (invite.user.self === user)) {
      if (invite.allocation) {
        return this.renderSelfAllocated();
      } else if (invite.user && invite.used) {
        return this.renderSelfAccepted();
      }
    } else if (invite.allocation) {
      return this.renderAllocated();
    } else if (invite.user && invite.used) {
      return this.renderAccepted();
    }
    return this.renderNotAccepted();
  }
}
/* eslint-enable max-len */

InvestorInvite.propTypes = {
  invite: PropTypes.object.isRequired,
  user: PropTypes.string.isRequired,
  invest: PropTypes.func.isRequired,
};

export default InvestorInvite;



// WEBPACK FOOTER //
// ./web/flows/deal/investors/invited/components/InvestorInvite/component.js